module.exports = __webpack_public_path__ + "img/page.6ac93625.png";